"user strict";

angular.module("core")
.constant("EMAIL_MAXLENGTH", 254)
.constant("POPOVER_POPUP_DELAY", 500)
.constant("POPOVER_MIN_ELEMENT", 3);



//////////////////
// WEBPACK FOOTER
// ./core/common/common.constant.js
// module id = 384
// module chunks = 0